import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { QnaformPage } from './qnaform';

@NgModule({
  declarations: [
    QnaformPage,
  ],
  imports: [
    IonicPageModule.forChild(QnaformPage),
  ],
})
export class QnaformPageModule {}



// WEBPACK FOOTER //
// ./src/pages/qnaform/qnaform.module.ts